import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { formatDate } from "../../../utils/formatDate";

export default function CommonPdfDiplomasSection( { resumeData, translations } ) {

    const { diplomas } = extractResumeDataDocumentSection( resumeData );
    const { documentLanguage, isAnonymous, isAlcyone } = extractResumeProperties( resumeData );

    const themeColor = isAlcyone ? '#09B4BF' : '#0B86C8';

    const styles = StyleSheet.create( {
        section: {
            flexDirection: 'row',
            marginBottom: 2,
            fontSize: 8,
        },
        leftColumn: {
            width: '16%',
        },
        rightColumn: {
            width: '80%',
            marginLeft: 6,
        },
        textStart: {
            margin: 0,
            color: "#000000",
            textAlign: "left"
        },
        bold: {
            fontWeight: 'bold',
        },
        textDate: {
            fontSize: 8,
            marginBottom: 0,
        },
        category: {
            fontSize: 8,
            color: themeColor,
            marginBottom: 1,
            marginTop: 2,
            textAlign: 'start',
        },
        sectionTitle: {
            fontSize: 12,
            fontWeight: 'bold',
            marginBottom: 2,
            textTransform: 'uppercase',
            color: themeColor,
        },
        titleContainer: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        line: {
            flexGrow: 1,
            height: 1,
            backgroundColor: themeColor,
            marginLeft: 5,
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginBottom: 5,
            marginTop: -5,
        },
    } );

    return (
        <View style={ [ styles.experienceItem, { marginTop: 10 } ] }>
            <View style={ styles.titleContainer }>
                <Text style={ styles.sectionTitle }>
                    { translations.pdf.diplomasTitle }
                </Text>
                <View style={ styles.line }/>
            </View>
            { diplomas
                .filter( ( diploma ) => diploma.from && ( diploma.to || diploma.isCurrent ) )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => (
                    <View key={ `diploma-${ index }` } wrap={ false }>
                        <View style={ styles.section }>
                            { index > 0 && (
                                <View style={ { height: 1, backgroundColor: themeColor, marginVertical: 2 } }/>
                            ) }
                            <View style={ styles.leftColumn }>
                                <Text style={ [ styles.bold, styles.textStart ] }>
                                    { isAnonymous ? translations.pdf.diplomasSchoolLabel : diploma.schoolName }
                                </Text>
                                <Text style={ styles.textDate }>
                                    { formatDate( diploma.from, documentLanguage ) }
                                    { " - " }
                                    { diploma.isCurrent ? translations.pdf.isCurrentLabel : formatDate( diploma.to, documentLanguage ) }
                                </Text>
                            </View>
                            <View style={ styles.rightColumn }>
                                { diploma.educationLevel?.translations?.[ documentLanguage ] && (
                                    <Text style={ styles.category }>
                                        { diploma.educationLevel.translations[ documentLanguage ] }
                                    </Text>
                                ) }
                                <Text>
                                    { diploma.diplomaTitle }
                                </Text>
                            </View>
                        </View>
                    </View>
                ) ) }
        </View>
    );
}
